import React, { useState, useEffect } from "react";
import "./styles.css";

const StreamLine = ({
  start,
  startStep,
  active,
  data,
  currentTick,
  tickDuration,
  simulation,
  bgcolor = "#383B61",
  isSip,
  className,
  lineIndex
}) => {
  const [left, setLeft] = useState(0);

  useEffect(() => {
    if (data?.length && simulation) {
      setLeft(-140 - 140 * (currentTick - startStep));
    }
  }, [data, simulation, currentTick, startStep]);

  return (
    <div className={`streams-streamline__wrapper ${className}`}>
      <div
        className="streams-streamline__innerwrapper"
        style={{
          transform: `translateX(${left}px)`,
          transition: `transform ${currentTick + 1 === startStep ? 0 : start ? tickDuration : 200
            }ms linear`
        }}
      >
        {[<div key={lineIndex} style={{ width: 772 }} />].concat(
          data?.map((item, index) => {
            let activeClass = "";
            if (isSip) {
              activeClass = index === currentTick ? "active-sip" : "";
            } else {
              activeClass =
                item.tp - 1 === currentTick ? "active-streamline-item" : "";
            }
            const showData =
              (item.exec_qty || item.quantity) &&
              (item.exec_price || item.price);

            const isNotReference = isSip && !item.isReference;
            const isDynamic = item.isDynamic;
            return (
              <div
                key={`${item.order_id}-${index}-${currentTick}-${lineIndex}`}
                className={`streamline-item ${activeClass} ${isNotReference ? "not-reference" : ""
                  } ${isDynamic ? "dynamic" : ""}`}
              >
                {showData
                  ? `${item.exec_qty || item.quantity} - ${item.exec_price ||
                  item.price}`
                  : ""}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default StreamLine;
